import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    applicant?: number;
    firstName: string;
    smoker?: string;
    updateLead(props: any): void;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    smoker?: string;
    partnerSmoker?: boolean;
}

export class SmokerStatus extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {
            hasError: false, 
            smoker: this.props.smoker, 
        };
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep(smoker: string) {
        if(this.props.applicant === 1) 
            this.props.updateLead({smoker: smoker}); 
        else
            this.props.updateLead({partnerSmoker: smoker}); 
        this.props.nextStep()
    }

    render() {

        return (
            <header className="App-header">
                <div className='wrapper'>
                    <h1 className='l'>And {this.props.applicant === 1 ? 'finally' : 'your partner'}</h1>
                    <h2 className='l'>{this.props.applicant === 1 ? 'Have you' : 'Have they'} smoked, vaped or used any nicotine replacement<br />products in the <span className='doddltext'>last 12 months?</span></h2>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className='boxty small'onClick={() => this.nextStep('No')}>
                                <div>
                                    <div><h2 className='btn'>No</h2></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='boxty small' onClick={() => this.nextStep('Yes')}>
                                <div>
                                    <div><h2 className='btn'>Yes</h2></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}
